import React from "react";
import DisplayComponent from "./DisplayComponent";
import { Lifter, Meet } from "types";
import get from "lodash/get";
import { WidgetId, useDisplaySettings } from "./DisplaySettingsProvider";

const TeamName = ({
  meet,
  currentLifter,
  id,
}: {
  meet: Meet;
  currentLifter: Lifter | undefined | null;
  id: WidgetId;
}) => {
  const { editMode } = useDisplaySettings();
  return (
    <DisplayComponent style={{ top: 80, left: 0 }} id={id}>
      {({ sizeMultiplier }: { sizeMultiplier: number }) => {
        const style = {
          fontSize: sizeMultiplier * 22,
          width: sizeMultiplier * 600,
        };

        const teamName = currentLifter
          ? get(currentLifter, "team", "")
          : "Team Name";

        return (
          <div style={style} className="lifter-details">
            {editMode ? "Team Name" : teamName}
          </div>
        );
      }}
    </DisplayComponent>
  );
};

export default TeamName;
